import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-not-on-target-mark',
    templateUrl: './not-on-target-mark.component.html',
    styleUrls: ['./not-on-target-mark.component.scss'],
    standalone: false
})
export class NotOnTargetMarkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
